var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M21.357 18.254A8.5 8.5 0 0 0 7.968 8.01 8.5 8.5 0 0 0 18.304 21.33L22.5 22.5l-1.143-4.246Z"
  })));
};
export default SvgComments;